/* Ponto de entrada da rota /portal-responsavel.

   Mesmas três exigências do carregador de rotas do AVA que Inteligência
   Educacional documenta em InteligenciaEducacional.jsx — export default
   connect()(...), defaultProps.hideLayout false, arquivo alcançável por
   import('../pages/' + local). Módulo independente: nenhum import de
   pages/InteligenciaEducacional/ aqui. */

import React, { Component } from "react";

import { connect } from "react-redux";

import App from "./App";
import Breadcrumb from "../../components/Breadcrumb";
import ProtectedRoute from "../../components/ProtectedRoute";

class PortalResponsavel extends Component {
  render() {
    return (
      <div className="d-flex flex-column align-items-left">
        {/* Quem abre o portal é o access_roles_links do papel (só o 8); o
            App ainda confere o papel ativo antes de buscar os alunos. */}
        <ProtectedRoute routeId={this.props.currentRoute} />
        <Breadcrumb current={this.props.currentRoute} />
        <App />
      </div>
    );
  }
}

PortalResponsavel.defaultProps = {
  hideLayout: false,
  hideContainer: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general
});

export default connect(mapStateToProps)(PortalResponsavel);
